module.exports = "https://img1.huilianyi.com/f/icon6.f7e69be6e0.appcore.png";